var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useEffect, useRef, useState } from "react";
import { useMergeRefs } from "../../../../common/useFallbackRef";
var ToggleV2Label = forwardRef(function (_a, ref) {
    var checkedLabel = _a.checkedLabel, uncheckedLabel = _a.uncheckedLabel, children = _a.children, className = _a.className, style = _a.style, otherProps = __rest(_a, ["checkedLabel", "uncheckedLabel", "children", "className", "style"]);
    var _b = useState(0), maxWidth = _b[0], setMaxWidth = _b[1];
    var labelRef = useRef(null);
    var mergedLabelRef = useMergeRefs([ref, labelRef]);
    useEffect(function () {
        var _a;
        if (!labelRef.current) {
            return;
        }
        var input = (_a = labelRef.current.parentNode) === null || _a === void 0 ? void 0 : _a.querySelector("input");
        if (!input) {
            return;
        }
        var isChecked = input.checked;
        var style = window.getComputedStyle(labelRef.current, ":before");
        var width = parseFloat(style.width);
        input.checked = !isChecked;
        var style2 = window.getComputedStyle(labelRef.current, ":before");
        var width2 = parseFloat(style2.width);
        input.checked = isChecked;
        setMaxWidth(Math.max(width, width2));
    }, [labelRef]);
    var styleGroup = __assign(__assign({}, style), { "--toggle-status-width": maxWidth / 16 + "rem" });
    var propsData = {};
    if (checkedLabel && uncheckedLabel) {
        propsData = {
            "data-fr-checked-label": checkedLabel,
            "data-fr-unchecked-label": uncheckedLabel,
        };
    }
    return (React.createElement("label", __assign({}, otherProps, { ref: mergedLabelRef, className: "fr-toggle__label ".concat(className || ""), style: styleGroup }, propsData), children));
});
export default ToggleV2Label;
